<template>
  <ul
    class="
      row
      no-gutters
      mt-n2 sm:mt-n4 md:mt-n5 lg:mt-n6
      ml-n2 sm:ml-n4 md:ml-n5
      py-1 md:py-2 lg:py-3
      mb-0
      list-unstyled
    "
  >
    <li
      v-for="(item, key) in items"
      :key="key"
      class="col-12 lg:col-3 flex flex-col pt-2 sm:pt-4 md:pt-5 lg:pt-6 pl-2 sm:pl-4 md:pl-5"
    >
      <div
        class="
          row
          relative
          sm:items-center lg:items-start
          lg:justify-center
          px-1 sm:px-2 md:px-3
          flex-grow-1
          py-1
        "
      >
        <!-- obrazek -->
        <div class="col-4 sm:col-3 md:col-2 lg:col-6 xl:col-5 lg:mb-2">
          <div class="embed-responsive embed-responsive-1by1 mb-0 rounded-sm">
            <component
              :is="item.svg"
              class="embed-responsive-item p-2 lg:p-0 image-contain"
              :icon-alt="item.text"
            />
          </div>
        </div>
        <!-- text -->
        <div class="col-8 sm:col-9 md:col-10 lg:col-12 flex-grow-1 lg:text-center static">
          <div class="form-row">
            <div class="col-12 sm:col">
              <p class="mb-0 sm:mb-1 text-base font-medium">
                {{ item.text }}
              </p>
              <p class="mb-2 sm:mb-0 lg:mb-4 text-sm">
                {{ item.description }}
              </p>
            </div>
            <div class="col-12 sm:col-auto lg:col-12 static">
              <router-link
                :to="item.link"
                class="btn btn-outline-primary stretched-link py-1 sm:py-2 rounded-pill"
              >
                {{ t('i_want_to_subscribe') }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

defineProps({
  items: {
    type: Array,
    required: true,
  },
})
</script>

<i18n>
  {
    "cs": {
    "i_want_to_subscribe": "Chci předplatit"
},
    "sk": {
    "i_want_to_subscribe": "Chcem predplatiť"
},
    "pl": {
    "i_want_to_subscribe": "Chcę się zapisać"
},
    "hu": {
    "i_want_to_subscribe": "Előfizetek"
},
    "de": {
    "i_want_to_subscribe": "Ich möchte abonnieren"
},
    "at": {
    "i_want_to_subscribe": "Ich möchte abonnieren"
},
    "ro": {
    "i_want_to_subscribe": "Doresc să mă abonez"
},
    "fr": {
    "i_want_to_subscribe": "Je souhaite m'abonner"
}
  }
</i18n>
